import styled from "styled-components";
import { Wrapper } from "../../components/styling-components/Wrapper";
import ContactForm from "../../components/main/ContactForm";
import { ContactItem } from "../../content-info/ContactH2H4";
import { Sizes } from "../../styles/Sizes";

const GPBox = styled.div`
  h4 {
    margin-bottom: calc( ${ Sizes.BaseUnit } *2);
  }
`;

export default function GraphicProfile() {
  return (
    <GPBox>
      <Wrapper>
        <ContactForm h2item={ContactItem[1].h2} h4item={ContactItem[1].h4} />
      </Wrapper>
    </GPBox>
  );
}
